import Script from 'next/script';
export default function AnalyticsScripts({
  nonce
}) {
  return <>
			<Script src="https://www.googletagmanager.com/gtag/js?id=UA-167998759-1" nonce={nonce} strategy="lazyOnload" data-sentry-element="Script" data-sentry-source-file="AnalysticsScripts.jsx" />

			<Script id="gtag-script" nonce={nonce} strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: `
						window.dataLayer = window.dataLayer || [];
						function gtag(){dataLayer.push(arguments);}
						gtag('js', new Date());
						gtag('config', 'UA-167998759-1');
                        gtag('config', 'AW-939226597');`
    }} data-sentry-element="Script" data-sentry-source-file="AnalysticsScripts.jsx" />

			<Script id="gtm-script" nonce={nonce} strategy="lazyOnload" dangerouslySetInnerHTML={{
      __html: `
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','GTM-5BFWPXR');
					`
    }} data-sentry-element="Script" data-sentry-source-file="AnalysticsScripts.jsx" />
            	<noscript dangerouslySetInnerHTML={{
      __html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5BFWPXR" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    }} />
		</>;
}